export default "__VITE_ASSET__qbZu694$__"